<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="TIEMPO" key="1">
        <g-master name="overtime"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  modalWidth="80%"
                  @action="masterAction"
                  :beforeSend="master.beforeSend"
                  ref="master"
        >
          <template slot="expandedRowRender" slot-scope="{text}">
            <template v-for="ve in master.valoresExpandidos">
              {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
            </template>
          </template>
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Empleado')"
                          :formItemConfig="fiOptions"
                          endpoint="empleados_en_reqliquidacion"
                          ref="empleado"
                          :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]">
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown v-bind="fiOptions"
                            endpoint="shifts_setup"
                            :label="$t('Tipo de turno')"
                            :formItemConfig="fiOptions"
                            :decorator="['id_rh_t_shifts_setup', { rules: [{ required: true, message: 'Valor requerido' }] }]">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown v-bind="fiOptions"
                            endpoint="hierarchy_lookup"
                            :label="$t('Estado')"
                            :formItemConfig="fiOptions"
                            :decorator="['status', { rules: [{ required: true, message: 'Valor requerido' }], initialValue: 'ACT' }]"
                            :params="status">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Trabajo realizado')">
                  <a-input
                    v-decorator="['work', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha y hora de inicio')">
                  <a-date-picker style="width: 100%"
                                 format="YYYY-MM-DD HH:mm"
                                 show-time
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 placeholder="Select Time"
                                 v-decorator="['start_time', { rules: [{ required: true, message: 'Valor requerido' }], initialValue: now }]"
                  />
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha y hora de fin')">
                  <a-date-picker style="width: 100%"
                                 format="YYYY-MM-DD HH:mm"
                                 show-time
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 placeholder="Select Time"
                                 v-decorator="['final_time', { rules: [{ required: true, message: 'Valor requerido'  }], initialValue: now }]"
                  />
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Cantidad de horas')" v-bind="fiOptions">
                  <a-input
                    readOnly
                    v-decorator="['n_hours', { rules: [
                          { required: false }]
                        }
                          ]">
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Año')" v-bind="fiOptions">
                  <a-select v-decorator="['year', { rules: [
                            { required: false, message: 'Valor requerido' },
                           ] }]" style="width: 100%">
                    <a-select-option v-for="year_ in years" :key="year_">
                      {{ year_ }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Mes')" v-bind="fiOptions">
                  <a-select v-decorator="['month', { rules: [
                            { required: false, message: 'Valor requerido'},
                           ] }]" style="width: 100%">
                    <a-select-option v-for="month_ in months_name" :key="month_.value">
                      {{ month_.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('Período')"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['period', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                            :params="period_request">
                </g-dropdown>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-tab-pane>
      <a-tab-pane tab="HISTÓRICO" key="2">
        <overtime-hist></overtime-hist>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    mounted () {
      this.yearsSelect()
    },
    data () {
      return {
        now: moment().format('Y-MM-DD HH:mm:ss'),
        horas: '',
        inicio: null,
        fin: null,
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        visibleHoras: false,
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        years: [],
        yearToday: parseInt(moment().format('YYYY')),
        status: {
          h_lookup_type: 'ESTADO_CONCEPTO_TIEMPO',
          use_code: true
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          valoresExpandidos: [
            {label: 'Trabajo realizado', column: 'work'},
            {label: 'Estado', column: 'status_desc'},
            {label: 'Cantidad de horas', column: 'n_hours'}
          ],
          endpoint: 'overtime',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: () => !this.$userIsInrol('Query')
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: () => !this.$userIsInrol('Query')
                }
              ]
            },
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id',
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: 'ID del empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre completo', dataIndex: 'nombre_empleado', sorter: true},
              {title: 'Fecha y hora de inicio', dataIndex: 'start_time', sorter: true},
              {title: 'Fecha y hora de fin', dataIndex: 'final_time', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'mes', sorter: true},
              {title: 'ID período', dataIndex: 'period', sorter: true},
              {title: 'Período', dataIndex: 'periodo', sorter: true},
              {title: 'Tipo de turno', dataIndex: 'shifts_setup', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_at', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'updated_at', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_emp'},
            {name: 'coc'},
            {name: 'status'},
            {name: 'work'},
            {name: 'start_time'},
            {name: 'final_time'},
            {name: 'month'},
            {name: 'year'},
            {name: 'period'},
            {name: 'id_rh_t_shifts_setup'},
            {name: 'n_hours'}
          ]
        }
      }
    },

    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            this.fin = action.record.final_time
            this.inicio = action.record.start_time
            this.$refs.master.modal.form.setFieldsValue({
              n_hours: this.calcularHoras(action.record.start_time, action.record.final_time)
            })

            this.$nextTick(() => {
              if (!JsUtils.isEmpty(action.record.id_emp)) {
                this.$refs.empleado && this.$refs.empleado.handleSearch(action.record.id_emp)
              }
            })
            break
          case 'fieldsChange':
            if (!JsUtils.isEmpty(action.changedFields) && !JsUtils.isEmpty(action.changedFields.final_time)) {
              this.fin = action.changedFields.final_time.value
              this.$refs.master.modal.form.setFieldsValue({
                n_hours: this.calcularHoras(this.inicio, this.fin)
              })
            }
            if (!JsUtils.isEmpty(action.changedFields) && !JsUtils.isEmpty(action.changedFields.start_time)) {
              this.inicio = action.changedFields.start_time.value
              this.$refs.master.modal.form.setFieldsValue({
                n_hours: this.calcularHoras(this.inicio, this.fin)
              })
            }
            break
        }
      },
      yearsSelect () {
        for (let i = this.yearToday - 1; i <= (this.yearToday + 5); i++) {
          this.years.push(i)
        }
      },
      calcularHoras (hora_inicio, hora_fin) {
        hora_inicio = new Date(hora_inicio)
        hora_fin = new Date(hora_fin)
        if (!JsUtils.isEmpty(hora_inicio) && !JsUtils.isEmpty(hora_fin) && hora_fin >= hora_inicio) {
          let diffTime = Math.abs(hora_fin - hora_inicio)
          return Math.round((diffTime / 1000 / 60 / 60) * 100) / 100
        } else {
          return ''
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/Overtime.vue